import React from "react";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import { UiContentCol, UiContentWr } from "../../../components/common/UiPageElements";
import { UiStepsWizard } from "../../../components/common/UiStepsWizard";
import { UiCol, UiRowContainer } from "../../../components/grid-container/GridContainer";
import incentiveCard from '../../../../../styles/img/incentive-work.jpg';
import { Accordion } from "react-bootstrap";
import { PlusIcon } from "../../../../../styles/img/svg/PlusIcon";

export const HowIncentiveWorks = (props) => {

    return (
        <>
            <UiContentWr>
                <UiRowContainer fluid="fluid" className="sb-incentive-process-wrapper sb-step-to-success">
                        <>
                            <div className="sb-accordion-wrapper sb-accordion-top-wr">
                                <Accordion>
                                    <Accordion.Item eventKey="0" key="0">
                                        <div className="d-flex">
                                            {/* <UiCol lg="3" >
                                                <div className="sb-incentive-process-wrapper__left-img-wrapper me-4">
                                                    <img src={incentiveCard} />
                                                </div>
                                            </UiCol> */}
                                            <UiCol lg="12" className={props.className}>
                                                <UiContentCol>
                                                    <Accordion.Header>
                                                        <UiCardTitle title="Your step to success" /> 
                                                        <span className="sb-accordion-wrapper__plus"><PlusIcon /></span>
                                                    </Accordion.Header>
                                                    <Accordion.Body>
                                                        <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.<br />Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>
                                                        <UiStepsWizard
                                                            wizardData={props.wizardData}
                                                        />
                                                    </Accordion.Body>
                                                </UiContentCol>
                                            </UiCol>
                                        </div>
                                    </Accordion.Item>

                                </Accordion>
                            </div>


                        </>
                        {/* :
                        <UiCol lg="12" className={props.className}>
                            <UiContentCol>
                                <UiCardTitle title="Your steps to success" />
                                <p>Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.<br />Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>
                                <UiStepsWizard
                                    wizardData={props.wizardData}
                                />
                            </UiContentCol>
                        </UiCol>
                    } */}
                </UiRowContainer>
            </UiContentWr>
        </>
    )
}


